import { appstr } from "@coreapp/utils/appstr";

/**
 * Shows a confirmation alert before deleting a shared filter or highlight.
 * Uses wsMgr.CreateReactAlert so the confirmation style is consistent
 * across the app (My tab trash button and edit mode trash button).
 */
export function confirmDeleteShared(
  wsMgr: { CreateReactAlert?: (...args: any[]) => void } | null | undefined,
  type: "filter" | "highlight",
  onConfirm: () => void
): void {
  if (!wsMgr?.CreateReactAlert) return;

  const title =
    type === "filter" ? appstr("Delete shared filter?") : appstr("Delete shared highlight?");
  const message =
    type === "filter"
      ? appstr("Delete shared filter confirm")
      : appstr("Delete shared highlight confirm");

  wsMgr.CreateReactAlert(title, message, onConfirm, () => {}, appstr("Delete"), appstr("Cancel"));
}
